export const FamilyType = [
    { label: "عائلات فقط", value: 1 },
    { label: "عائلات + شباب", value: 2 },
    { label: "شباب فقط", value: 3 }
]

export const StayType = [
    { label: "إقامة مبيت", value: "overnight" },
    { label: "استخدام يومي", value: "day_use" }
]

export const ApartmentType = [
    { label: "شقة", value: "apartment" },
    { label: "فيلا", value: "villa" },
    { label: "شاليه", value: "chalet" },
    { label: "بيت", value: "house" },
    { label: "استوديو", value: "studio" },
    { label: "شقة فندقية", value: "hotel_apartment" },
    { label: "شقة فندقية", value: "hotel_apartment" },
]